import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { StudentBasicListResponseDto } from '@whetstoneeducation/hero-common';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import {MatDialog} from "@angular/material/dialog";
import {BulkEventStudentCsvComponent} from "../bulk-event-student-csv/bulk-event-student-csv.component";

export enum HeroEventStudentColumnsEnum {
  STUDENT_NAME = 'Student Name',
  STUDENT_ID = 'Student ID',
  GRADE = 'Grade',
  ACTION = 'Action'
}

@Component({
  selector: 'app-hero-event-create-edit-student-table',
  templateUrl: './hero-event-create-edit-student-table.component.html',
  styleUrls: ['./hero-event-create-edit-student-table.component.scss']
})
export class HeroEventCreateEditStudentTableComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() students: StudentBasicListResponseDto[];
  @Output() removeStudent = new EventEmitter<number>();
  @Output() showAddStudentModal = new EventEmitter();
  @Output() showBulkStudentProfileUploadModal = new EventEmitter();
  public filteredStudentList: StudentBasicListResponseDto[];
  public searchControl = new FormControl('');
  public searchSubscription: Subscription;

  constructor(
    public dialog: MatDialog
  ) {

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.students) {
      this.searchControl.setValue(null);
      this.filteredStudentList = changes.students.currentValue;
    }
  }

  ngOnInit() {
    this.filteredStudentList = this.students;
    this.searchSubscription = this.searchControl.valueChanges.subscribe(
      (searchValue) => {
        if (searchValue !== '') {
          this.filteredStudentList = this.students.filter((student) => {
            return (
              student.firstName
                .toLowerCase()
                .includes(searchValue.toLowerCase()) ||
              student.lastName
                .toLowerCase()
                .includes(searchValue.toLowerCase()) ||
              student.studentExtId
                .toLowerCase()
                .includes(searchValue.toLowerCase())
            );
          });
        }
      }
    );
  }

  ngOnDestroy() {
    this.searchSubscription.unsubscribe();
  }

  public get displayedColumns() {
    return Object.values(HeroEventStudentColumnsEnum);
  }

  public columnValues = {
    [HeroEventStudentColumnsEnum.STUDENT_NAME]: ['Student Name'],
    [HeroEventStudentColumnsEnum.STUDENT_ID]: ['Student ID'],
    [HeroEventStudentColumnsEnum.GRADE]: ['Grade'],
    [HeroEventStudentColumnsEnum.ACTION]: ['Remove']
  };

  protected readonly columns = HeroEventStudentColumnsEnum;


}
